import { Component, OnInit, Input, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../shared/material/material.module';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AccessPlan } from '../../../../core/generated';
import { ExternalPayerService } from '../services/external-payer.service';
import { fadeIn, listStagger } from '../../shared/animations';

@Component({
  selector: 'app-payer-pending-plans',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './payer-pending-plans.component.html',
  styleUrl: './payer-pending-plans.component.scss',
  animations: [fadeIn, listStagger]
})
export class PayerPendingPlansComponent implements OnInit {
  @Input() userCpf!: string;

  private externalPayerService = inject(ExternalPayerService);
  private snackBar = inject(MatSnackBar);

  plans = signal<AccessPlan[]>([]);
  isLoading = signal(false);
  processingPlanId = signal<number | null>(null);

  ngOnInit(): void {
    this.loadPendingPlans();
  }

  loadPendingPlans(): void {
    if (!this.userCpf) return;
    this.isLoading.set(true);
    this.externalPayerService.getPendingPlansByUserCpf(this.userCpf).subscribe({
      next: (data) => { this.plans.set(data); this.isLoading.set(false); },
      error: () => { this.snackBar.open('Erro ao carregar planos pendentes.', 'Fechar', { duration: 4000 }); this.isLoading.set(false); }
    });
  }

  onAccept(plan: AccessPlan): void {
    if (!plan.id) return;
    this.processingPlanId.set(plan.id);
    this.externalPayerService.acceptPayment(plan.id).subscribe({
      next: () => {
        this.snackBar.open('Responsabilidade aceita com sucesso!', 'Fechar', { duration: 3000, panelClass: ['success-snackbar'] });
        this.plans.update(list => list.filter(p => p.id !== plan.id));
        this.processingPlanId.set(null);
      },
      error: () => { this.snackBar.open('Erro ao aceitar o plano.', 'Fechar', { duration: 4000 }); this.processingPlanId.set(null); }
    });
  }

  onReject(plan: AccessPlan): void {
    if (!plan.id) return;
    this.processingPlanId.set(plan.id);
    this.externalPayerService.rejectPayment(plan.id).subscribe({
      next: () => {
        this.snackBar.open('Responsabilidade rejeitada.', 'Fechar', { duration: 3000 });
        this.plans.update(list => list.filter(p => p.id !== plan.id));
        this.processingPlanId.set(null);
      },
      error: () => { this.snackBar.open('Erro ao rejeitar o plano.', 'Fechar', { duration: 4000 }); this.processingPlanId.set(null); }
    });
  }

  isProcessing(planId?: number): boolean {
    return this.processingPlanId() === planId;
  }

  formatCurrency(value?: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value ?? 0);
  }

  formatCnpj(cnpj?: string): string {
    if (!cnpj) return 'N/A';
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }
}
